<template>
  <div id="rationale-list">
    <rationale-card
      v-for="(answer, index) in answers"
      :id="`answer-rationale-${answer.id}`"
      :key="answer.id"
      :answer-html="answer.content"
      :rationale="answer.rationale"
      :correct="answer.correct"
      :index="index"
      :is-sata="isSata"
      :selected="selected(answer.id)"
      :use-answer-labels="useAnswerLabels"
    />
  </div>
</template>

<script>
import RationaleCard from './RationaleCard.vue';
import MultipleChoiceMixin from '@/mixins/multipleChoice.js';

export default {
  name: 'RationaleList',
  components: {
    RationaleCard,
  },
  mixins: [MultipleChoiceMixin],
  props: {
    // needed by mixin
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    answerIds: {
      type: Array,
      default: () => [],
    },
    isSata: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    useAnswerLabels() {
      return this.$store.getters['app/answerLabelsEnabled'];
    },
  },
  methods: {
    selected(answerId) {
      return this.answerIds.includes(answerId);
    },
  },
};
</script>

<style lang="scss" scoped>
#rationale-list {
  margin-top: 1rem;
}
</style>
